(function () {
  'use strict';

  var PHONE = '573212494214';
  var btn, countEl, labelEl;

  function money(cents) {
    var amount = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return '$' + amount;
  }

  function buildMessage(cart) {
    var mesa = cart && cart.attributes && cart.attributes.Mesa ? String(cart.attributes.Mesa) : '';

    /* Carrito vacío: el cliente quiere información antes de comprar. */
    if (!cart || !cart.items || !cart.items.length) {
      return '¡Hola! Estoy viendo la carta de DON y quiero información.';
    }

    var lines = ['¡Hola! Quiero confirmar este pedido de DON:', ''];
    if (mesa) { lines.push('📍 ' + mesa); lines.push(''); }
    cart.items.forEach(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : '';
      lines.push(item.quantity + 'x ' + item.product_title + variant + ' — ' + money(item.final_line_price));
    });
    lines.push('');
    lines.push('Total: ' + money(cart.total_price));
    lines.push('');
    lines.push(mesa && mesa.toLowerCase().indexOf('mesa') === 0
      ? '¿Lo confirmamos y cómo prefieres pagar?'
      : '¿Confirmamos para recoger o domicilio y el método de pago?');
    return lines.join('\\n');
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!btn) return;
        btn.dataset.cart = JSON.stringify(cart);
        pintar(cart.item_count || 0);
      })
      .catch(function () { pintar(0); });
  }

  /* El botón está siempre visible: sirve para pedir y también para preguntar. */
  function pintar(n) {
    if (!btn) return;
    btn.classList.add('is-visible');
    if (countEl) {
      countEl.textContent = n;
      countEl.style.display = n > 0 ? '' : 'none';
    }
    if (labelEl) {
      labelEl.textContent = n > 0 ? 'Pedir por WhatsApp' : 'Escríbenos';
    }
    btn.setAttribute('aria-label', n > 0 ? 'Pedir por WhatsApp' : 'Escríbenos por WhatsApp');
  }

  function onClick() {
    var cart = null;
    try { cart = JSON.parse(btn.dataset.cart || 'null'); } catch (e) {}
    var text = encodeURIComponent(buildMessage(cart));
    window.open('https://wa.me/' + PHONE + '?text=' + text, '_blank', 'noopener');
  }

  function init() {
    btn = document.querySelector('[data-radical-wa-fab]');
    if (!btn) return;
    countEl = btn.querySelector('.rdc-wa-fab__count');
    labelEl = btn.querySelector('.rdc-wa-fab__label');
    btn.addEventListener('click', onClick);
    document.addEventListener('cart:update', refresh);
    document.addEventListener('cart:updated', refresh);
    pintar(0);
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();